import { message } from 'antd';
import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetContractCount = () => {
  const client = useApi();

  return useQuery('get-contract-count', () => client.get('/multiaccess/contract/count').then((res) => res.data), {
    onError() {
      message.error('Request failed to get the contract count');
    },
  });
};
